// extracted by mini-css-extract-plugin
module.exports = {"warnings":"styles_warnings__2zI6I","warningItem":"styles_warningItem__1bH8w"};